// @ts-nocheck

import { type StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { BoomStepStatuses } from '../types/steps';
import { BoomUserStatuses } from '../types/user';

import {
  selectBoomUserProgress,
  selectBoomUserProgressEntityStatus,
  selectBoomUserStatus,
} from './user/userPrimary.selector';

type SelectorPropsType = {
  stepId: string;
};

export const selectBoomUserTotalWinnings: Selector<number> = (state: StateType) => {
  const progress = selectBoomUserProgress(state);

  return Object.keys(progress).reduce(
    (acc, stepId) => (progress[stepId].wonAmount ? acc + progress[stepId].wonAmount : acc),
    0,
  );
};

export const selectBoomUserProgressAllIsCompleted: Selector<boolean> = (state: StateType) => {
  const progress = selectBoomUserProgress(state);

  return Object.keys(progress).every((stepId) => progress[stepId].status === BoomStepStatuses.WON);
};

export const selectBoomUserNbWonSteps: Selector<number> = (state: StateType) => {
  const progress = selectBoomUserProgress(state);

  return Object.keys(progress).filter((stepId) => progress[stepId]?.status === BoomStepStatuses.WON).length;
};

export const selectIsBoomUserOptIn: Selector<boolean> = (state) => selectBoomUserStatus(state) === BoomUserStatuses.IN;

export const selectBoomUserProgressStepIsCompleted: Selector<boolean> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBoomUserProgressEntityStatus(state, props) === BoomStepStatuses.WON;
